import { isNativePlatform } from 'students/utils/isNativePlatform';

import {
  ENV_AUTH_URL,
  ENV_IDLE_TIMER,
  ENV_ORDNETT_SEARCH_ENDPOINT,
  ENV_PING_TIMER,
  ENV_SERVER_URL
} from './envs';

import { isProd, isTest } from './modes';

export { isProd, isTest };
export const LINGU_COPYRIGHT = `${new Date().getFullYear()} Lingu AS`;
// preval`module.exports = new Date().getFullYear() + ' Lingu AS';` || '';
export const DEFAULT_IDLE_TIMER = parseInt(ENV_IDLE_TIMER as string, 10) || 180000; // 3min
export const DEFAULT_PING_TIMER = parseInt(ENV_PING_TIMER as string, 10) || 5000; // 5sec

// CSS classes implemented by WebView in the Lingu mobile app
export const PADDINGABLE_FOR_MOBILE_STATUS_BAR_CLASS =
  'paddingable-for-mobile-status-bar ln-pt-safe ln-pr-safe';

// Runtime constants
export const APP_SERVER_URL =
  getRuntimeConstantByName('APP_SERVER_URL') || ENV_SERVER_URL || 'https://my.lingu.com';

// Native: absolute URL from env (Capacitor runs on `capacitor://localhost`, no real host).
// Dev web: absolute URL from env (dev server has no `/api` proxy, hits staging directly).
// Prod web: relative `/api` — same-origin, so requests adapt to whichever host serves
// the bundle (`my.lingu.com`, preview deploys, etc.).
const useAbsoluteApiUrl = isNativePlatform() || !isProd;
export const API_URI = useAbsoluteApiUrl ? `${APP_SERVER_URL}/api` : '/api';

export const AUTH_URL = ENV_AUTH_URL;

export const ORDNETT_SEARCH_ENDPOINT =
  getRuntimeConstantByName('ORDNETT_SEARCH_ENDPOINT') ||
  ENV_ORDNETT_SEARCH_ENDPOINT ||
  (isProd ? '' : 'https://my.lingu.com/api/ordnett-proxy');

function getRuntimeConstantByName(name: string): string | undefined {
  const element = document.querySelector(`meta[name="${name}"]`);

  if (element instanceof HTMLMetaElement) {
    return element.content;
  }
  return undefined;
}

export const APP_DOM_ID = 'lingu-app';

export const CONTACT_US_URL = 'https://lingu.no/contact-us';

export function courseRouteLinkFromSlug(slug: string): string {
  return `/courses/${slug}`;
}
